<script setup lang="ts">
interface Props {
	imageLocation?: string | undefined;
	isEventActive?: boolean | true;
}

defineProps<Props>();

const defaultSilk = computed(() => {
	return "https://resources.betway.com/Resources/Global/images/racingSilks/desktop/default-silkGrey.png";
});

const handleNotFoundImages = (e: any) => {
	e.target.src = defaultSilk.value;
};
</script>
<template>
	<NuxtImg
		contain
		height="35"
		width="35"
		@error="handleNotFoundImages"
		:src="imageLocation && isEventActive ? `https://content.betwayarabia.com${imageLocation}` : defaultSilk"
	/>
</template>
